<template>
  <div id="app" v-title title="视维科技">
    <router-view />
  </div>
</template>
<script>
import title from './utils/auTitle';
export default{
  mounted(){
    if(this._isMobile()){
      console.log('手机端');
      window.location.href = 'http://m.sharpvision.tech/'
      // window.location.href = 'http://msw.byszdd.com/'
    }
  },
  methods:{
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  }
}
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
a{
  text-decoration: none;
}
</style>
